import React from 'react'
import './navbar.css'
import logo from '../../assets/VIGUARD.png'

const Navbar = () => {
  return (
    <nav className="viGuard__Navbar">
      <div className="viGuard__navbar-links_logo">
        <img src={logo} alt="viGuard logo" />
      </div>
    </nav>
  )
}

export default Navbar
